module.exports = __webpack_public_path__ + "static/media/butt_cont.8fd44836.png";